export const flatten = (object, appendName = false) => {
    let returnObj = {};

    const traverse = (object, prefix = '') => {
        Object.keys(object).forEach((ele) => {
            if (Object.prototype.toString.call(object[ele]) === '[object Object]') {
                traverse(object[ele], `${prefix}${ele}.`);
            } else {
                returnObj[appendName ? `${prefix}${ele}` : ele] = object[ele];
            }
        });
    };

    traverse(object);

    return returnObj;
};
